import { ComponentType } from 'react';

import { PropertyComponentProps } from './components/ModelProperty';

export interface PropertyConfiguration {
  displayName?: string;
  readOnly: boolean;
  required: boolean;
}

const defaultBaseConfiguration: PropertyConfiguration = {
  readOnly: false,
  required: false,
};

export interface PropertySchemaDefinition<TValue, TCustomConfiguration> {
  component: ComponentType<PropertyComponentProps<TValue, TCustomConfiguration>>;
}

export interface PropertySchema<TValue, TCustomConfiguration = {}> extends PropertySchemaDefinition<
  TValue,
  TCustomConfiguration
> {
  name: string;
  configuration: PropertyConfiguration & TCustomConfiguration;
}

type ConfigurationProperties<CustomConfiguration> = PropertyConfiguration & CustomConfiguration;
type DefinitionWithDefaultConfiguration<TValue, TCustomConfiguration> = PropertySchemaDefinition<
  TValue,
  TCustomConfiguration
> & {
  defaultConfiguration?: Partial<PropertyConfiguration> & TCustomConfiguration;
};

// eslint-disable-next-line @typescript-eslint/no-unsafe-declaration-merging
export class PropertySchema<TValue, TCustomConfiguration = {}> {
  configuration: ConfigurationProperties<TCustomConfiguration>;

  constructor(name: string, definition: DefinitionWithDefaultConfiguration<TValue, TCustomConfiguration>) {
    Object.assign(this, definition);

    this.name = name;
    this.configuration = Object.assign({}, defaultBaseConfiguration, definition.defaultConfiguration);
  }

  configure(configuration: Partial<PropertyConfiguration> & Partial<TCustomConfiguration>) {
    const object = new PropertySchema<TValue, TCustomConfiguration>(this.name, this);
    Object.assign(object.configuration, configuration);
    return object;
  }
}
